import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ISearchParam } from '../BaseApp'
import { handleRequestError } from '../../services/api'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { IAxiosDefaultDataObject } from '../../config'
import { IDataDisplayerHeaderOptionActionButton, IDataDisplyerItemActionOption } from '../../components/DataDisplayer/DataDisplayer'
import { IDynamicForm } from '../../components/Form/DynamicForm'
import AdminDynamicBasePage from '../admin/AdminDynamicBasePage'
import { useReturnCurrentPageType } from '../admin/adminPagesSlice'
import { createOrUpdateElementData } from '../../components/Form/formsSlice'
import { addNewItem, useReturnAllItems } from '../items/itemsSlice'
import ItemsApp from '../items/ItemsApp'
import { addNewIssue, deleteIssue, setSelectedIssues, updateAllIssues, updateIssue, updateIssusesLoadingStatus, updateIssusesPagination, updateIssusesSearch, updateIssusesSearchParams, useReturnAllIssuses, useReturnIssuesLoadingStatus, useReturnIssuesPagination, useReturnIssuesSearch } from './issuesSlice'
import IssuesApp, { IIssuesModal, issuesTypesList } from './IssuesApp'
import NewIssueModal from './NewIssueModal'
import { useReturnCurrentUser } from '../user/userSlice'
import ViewIssueModal from './ViewIssueModal'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { ICellRendererParams } from 'ag-grid-community'
import { width } from '@mui/system'
import GridData from '../../components/GridData/GridData'
import PageHeadSection from '../admin/components/PageHeadSection'
import { IconButton } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'

interface IProps {
    itemId?: number,
    hidePageHeadSection?: boolean,
    noSectionBoxWrap?: boolean,
    customHandleLoadItems?: (
                page: number, 
                search: string | null, 
                disablePagination: boolean, 
                addItems?: boolean, 
                searchParams?: ISearchParam[]
    ) => Promise<any>,
    disableAddNew?: boolean,
    forceRefresh?: (status: boolean) => void,
    forceRefreshStatus?: boolean,
    executeAfterCreate?: (issue: IIssuesModal) => void,
}

export default function IssuesList(props: IProps) {

    const { itemId, hidePageHeadSection, noSectionBoxWrap, customHandleLoadItems, disableAddNew, forceRefresh, forceRefreshStatus, executeAfterCreate } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { pagination, search, searchParams, selectedIssues, loading } = useSelector((state: RootState) => state.issues)

    const [showNewIssueModel, setShowNewIssueModel] = useState<boolean>(false)
    const [showIssueViewModal, setShowIssueViewModal] = useState<boolean>(false)

    const [showIssueId, setShowIssueId] = useState<number>(0)

    const [issueId, setIssueId] = useState<number>(0)
    const [resolveIssue, setResolveIssue] = useState<boolean>(false)

    const pageType = useReturnCurrentPageType()
    const issuesList = useReturnAllIssuses()

    // const pagination = useReturnIssuesPagination()
    // const loading = useReturnIssuesLoadingStatus()
    // const search = useReturnIssuesSearch()

    const issuesApp = new IssuesApp()
    const currentUser = useReturnCurrentUser()

    /**
     * Update loading status
     */
    const updateLoadingStatus = (status: boolean) => dispatch(updateIssusesLoadingStatus({ loading: status }))

    /**
     * Load issues
     */
    const loadIssues = (page: number, search: string|null, disablePagination: boolean, addItems?: boolean, searchParams?: Array<ISearchParam>) => {
        updateLoadingStatus(true)


        let load = issuesApp.listOfInstances(page, search, disablePagination, addItems, searchParams)

        if (itemId){
            load = issuesApp.listOfInstancesForItem(itemId, page, search, disablePagination, addItems, searchParams)
        }

        load
            .then(response => {

                const { data } = response
                const results: Array<IIssuesModal> = data.results

                if (addItems){
                    results.map((singleItem) => dispatch(addNewIssue(singleItem)))
                }else{
                    dispatch(updateAllIssues([]))
                    dispatch(updateAllIssues(results))
                }
                
                dispatch(updateIssusesPagination({
                    count: data.count,
                    current_page: page,
                    total_pages: data.total_pages
                }))

                updateLoadingStatus(false)

            })
            .catch(error => {

                handleRequestError(error, dispatch)
                updateLoadingStatus(false)

            })
    }

    /**
     * Delete issue
     */
    const handleDeleteIssue = (id: number) => {

        updateLoadingStatus(true)

        issuesApp.deleteInstance(id)
            .then(response => {
                updateLoadingStatus(false)

                dispatch(deleteIssue({ id: id }))
                dispatch(updateIssusesPagination({
                    ...pagination,
                    count: pagination.count - 1
                }))

                updateQuickNotificationDetails(true, "Done!", "success", dispatch)
            })
            .catch(error => {
                updateLoadingStatus(false)
                handleRequestError(error, dispatch)
            })

    }

    /**
     * Handle delete many issues
     */
    const handleDeleteManyIssues = (records: Array<IAxiosDefaultDataObject>) => {
        updateLoadingStatus(true)

        issuesApp.deleteManyInstances(records)
            .then(response => {
                updateLoadingStatus(false)

                
                records.map((record) => {
                    dispatch(deleteIssue({ id: record.id }))
                })

                dispatch(updateIssusesPagination({
                    ...pagination,
                    count: pagination.count - records.length
                }))

                updateQuickNotificationDetails(true, "Done!", "success", dispatch)
            })
            .catch(error => {
                updateLoadingStatus(false)
                handleRequestError(error, dispatch)
            })   
    }

    /**
     * Handle update search
     */
    const handleUpdateSearch = (search: string) => dispatch(updateIssusesSearch({ search: search }))

    /**
     * actions
     */
    const itemActionOptions: Array<IDataDisplyerItemActionOption> = [
        {
            icon: "done",
            label: "Resolve",
            onClick: (rawItem) => {
                setIssueId(rawItem.id)
                setResolveIssue(true)
                setShowNewIssueModel(true)
            },
        },
        {
            icon: "show",
            label: "View",
            onClick: (rawItem) => {
                // navigate("/panel/issues/view/" + rawItem.id)
                setShowIssueId(rawItem.id)
                setShowIssueViewModal(true)
            },
        },
    ]

    /**
     * Filter Form
     */
    const filterForm: IDynamicForm = {
        name: "issues-data-displayer-filter-form",
        elements: currentUser.is_superuser ? [
            {
                id: "type",
                xs: 3,
                type: "Select",
                label: "Type",
                fullWidth: true,
                displayForItem: true,
                addNoneItem: true,
                items: issuesTypesList
            },
            {
                id: "item_id",
                xs: 3,
                type: "DynamicSelect",
                label: "Item",
                fullWidth: true,
                addNoneItem: true,
                itemsList: useReturnAllItems,
                modelTitleParam: "title",
                appClass: new ItemsApp(),
                addNewItem: addNewItem,
            },
            {
                id: "resolved_by",
                xs: 3,
                type: "SelectUser",
                label: "Resolved by",
                fullWidth: true,
                addNoneItem: true,
            },
            {
                id: "reported_by",
                xs: 3,
                type: "SelectUser",
                label: "Reported by",
                fullWidth: true,
                addNoneItem: true,
            },
        ] : [
            {
                id: "type",
                xs: 6,
                type: "Select",
                label: "Type",
                fullWidth: true,
                displayForItem: true,
                addNoneItem: true,
                items: issuesTypesList
            },
            {
                id: "item_id",
                xs: 6,
                type: "DynamicSelect",
                label: "Item",
                fullWidth: true,
                addNoneItem: true,
                itemsList: useReturnAllItems,
                modelTitleParam: "title",
                appClass: new ItemsApp(),
                addNewItem: addNewItem,
            },
        ]
    }

    /**
     * Load 
     */
    useEffect(() => {
        
        if (props.itemId){

            let issuesToDelete: Array<number> = []

            issuesList.map((trans) => {
                if (trans.item_id !== props.itemId){
                    issuesToDelete.push(trans.id)
                }
            })

            issuesToDelete.map((del) => dispatch(deleteIssue({ id: del })))

        }

    }, [props.itemId, issuesList])

    /**
     * Hide new modal
     */
    const hideNewIssueModal = () => {
        setShowNewIssueModel(false)
        setResolveIssue(false)
        setIssueId(0)
    }

    return(
        <>
            <NewIssueModal issueId={issueId} resolveIssue={resolveIssue} itemId={itemId} shown={showNewIssueModel} handleClose={hideNewIssueModal} executeAfterCreate={executeAfterCreate} />
            <ViewIssueModal shown={showIssueViewModal} issueId={showIssueId} handleClose={() => setShowIssueViewModal(false)}  />

            {!hidePageHeadSection && <PageHeadSection pageName="issues" customActionButtons={[
                  {
                    icon: "new",
                    label: "New Issue",
                    onClick: () => navigate("/panel/issues/new"),
                    // customContent: (button, selectedItems) => {

                    //     return <Button disabled={itemContained ? true : false} className="general-button admin-style" onClick={() => handleUpdateModalOpenStatus(true)} startIcon={<GenerateIcon icon="new" />}>Add new</Button>
                    // },
                }
            ]} />}

            <SectionBoxContainer noWrap={noSectionBoxWrap ? true : false}>
                <GridData
                    items={issuesList}
                    columns={issuesApp.gridDataColumns}
                    // columns={[
                    //     {
                    //         field: "status",
                    //         headerName: "Status",
                    //         type: "status"
                    //     },
                    //     {
                    //         field: "issue_type",
                    //         headerName: "Type",
                    //         type: "status"
                    //     },
                    //     {
                    //         field: "item_title",
                    //         headerName: "Item",
                    //         cellRenderer: (params: ICellRendererParams<IIssuesModal>) => {
                    //             if (!params.data){
                    //                 return params.value
                    //             }

                    //             return <a className="data-grid-link" target='_blank' href={"/panel/items/view/" + params.data.item_id}><h3 className="title">{params.value}</h3></a>
                    //         }
                    //     },
                    //     {
                    //         field: "reported_by_title",
                    //         headerName: "Reported by",
                    //         width: 250,
                    //     },
                    //     {
                    //         field: "timestamp",
                    //         headerName: "Reported on",
                    //         type: "date",
                    //         width: 250
                    //     },
                    //     {
                    //         field: "resolved_by_title",
                    //         headerName: "Resolved by",
                    //         width: 250,
                    //     },
                    //     {
                    //         field: "resolved_at",
                    //         headerName: "Resolved on",
                    //         type: "date",
                    //         width: 250
                    //     },
                    // ]}
                    selectedItems={selectedIssues}
                    pagination={pagination}
                    search={search ? search : ""}
                    searchParams={searchParams}
                    loading={loading}
                    actionButtons={[
                        {
                            icon: "show",
                            isIconButton: true,
                            onClick(data, dispatch, navigate) {
                                setShowIssueId(data.id)
                                setShowIssueViewModal(true)
                            },
                        },
                        {
                            icon: "done",
                            isIconButton: true,
                            onClick(data, dispatch, navigate) {
                                setIssueId(data.id)
                                setResolveIssue(true)
                                setShowNewIssueModel(true)
                            },
                            customButton(data, dispatch, navigate) {
                                
                                const resolve = () => {
                                    setIssueId(data.id)
                                    setResolveIssue(true)
                                    setShowNewIssueModel(true)
                                }

                                return(
                                    <IconButton disabled={data.resolved} color="success" onClick={() => resolve()}>
                                        <GenerateIcon icon="done" />
                                    </IconButton>
                                )
                            },
                        },
                        {
                            icon: "delete",
                            color: "error",
                            isIconButton: true,
                            onClick(data, dispatch, navigate) {
                                handleDeleteIssue(data.id)
                            },
                        }
                    ]}
                    headerOptions={[
                        {
                            label: "Add new",
                            icon: "new",
                            onClick: () => setShowNewIssueModel(true),
                            disabled: disableAddNew ? true : false
                        }
                    ]}
                    handleLoadItems={customHandleLoadItems ? customHandleLoadItems : issuesApp.listOfInstances}
                    updateSearch={(search) => dispatch(updateIssusesSearch({ search: search }))}
                    setSelectedItems={(items) => dispatch(setSelectedIssues(items))}
                    onDeleteItem={issuesApp.deleteInstance}
                    onDeleteManyItems={issuesApp.deleteManyInstances}
                    deleteItem={(id, dispatch) => dispatch(deleteIssue({ id: id }))}
                    updateLoading={updateLoadingStatus}
                    updateItemSearchParams={(params) => dispatch(updateIssusesSearchParams(params))}
                    addNewItem={(item, dispatch) => dispatch(addNewIssue(item))}
                    updateItem={(item, dispatch) => dispatch(updateIssue(item))}
                    updateAllItems={(items, dispatch) => dispatch(updateAllIssues(items))}
                    updateItemsPagination={(pagination, dispatch) => dispatch(updateIssusesPagination(pagination))}
                    // config={{
                    //     viewItemLink: "/panel/transactions/view/[id]",
                    //     editItemLink: "/panel/transactions/edit/[id]",
                    //     filterForm: filterForm,
                    //     rowHeight: 50
                    // }}
                    config={issuesApp.gridConfig}
                    forceRefresh={forceRefresh}
                    forceRefreshStatus={forceRefreshStatus}
                />
            </SectionBoxContainer>

            {/* <AdminDynamicBasePage 
                appClass={issuesApp}
                itemsList={issuesList}
                pagination={pagination}
                loading={loading}
                search={search}
                updateLoadingStatus={updateLoadingStatus}
                loadItems={loadIssues}
                deleteItem={handleDeleteIssue}
                deleteManyItems={handleDeleteManyIssues}
                updateSearch={handleUpdateSearch}
                itemsActionOptions={itemActionOptions}
                filterForm={filterForm}
                hidePageHeadSection={hidePageHeadSection ? hidePageHeadSection : pageType == "base" ? false : true}
                customHeaderOptionActionButtons={[
                    {
                        icon: "new",
                        label: "New Issue",
                        onClick: () => setShowNewIssueModel(true)
                    }
                ]}  
                disableSearch={true}
                // customPageHeadSectionActionButtons={[]}
            /> */}
        </>
    )
}